import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateMissionSubjects } from '@store/slice/missionSlice'
import { updateNotification, updateData } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import useDynamicForm from '@hook/useDynamicForm'
import useDeleteButton from '@hook/useDeleteButton'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'

const ListMissionSubjects = () => {
  const { missionSubjects } = useSelector(state => state.mission)
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const toggleDynamicForm = useDynamicForm()
  const deleteButton = useDeleteButton()
  const [t] = useTranslation('common')

  const dataMissionSubjects = { nodes: [] }
  if (missionSubjects) {
    dataMissionSubjects.nodes = Object.values(missionSubjects)
  }

  const removeMissionSubject = missionSubject => {
    const { id, links } = missionSubject
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code === 200) {
        const missionSubject = missionSubjects[id]
        const missionSubjectsList = { ...missionSubjects }
        delete missionSubjectsList[id]
        dispatch(updateMissionSubjects({ ...missionSubjectsList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: missionSubject.subject }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/mission-subjects`, response => {
      const { code, models, options } = response
      if (code === 200) {
        dispatch(updateMissionSubjects(models))
        dispatch(updateData({ missionSubjects: options }))
      }
    })
  }, [])

  return (
    <Div cssClass='users-list'>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('missionSubject', 'missionSubjects'),
          text: t('actions.add')
        }}
        />
      </Div>
      <h2 className='zone-title'>{t('titles.mission_subjects_list')}</h2>
      {null !== missionSubjects && dataMissionSubjects.nodes.length
        ? <>
          <Table data={dataMissionSubjects} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>ID</HeaderCell>
                    <HeaderCell>{t('table.Name')}</HeaderCell>
                    <HeaderCell>{t('table.Parent')}</HeaderCell>
                    <HeaderCell>{t('table.UpdatedAt')}</HeaderCell>
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.id}</Cell>
                      <Cell>{item.subject}</Cell>
                      <Cell>{item.parent ? item.parent.label : '-'}</Cell>
                      <Cell>{item.updatedAt}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-create',
                            cssClass: 'is-info is-small',
                            callback: () => toggleDynamicForm('missionSubject', 'missionSubjects', item)
                          }
                        ]} />
                        {/* {deleteButton(item, item.name, removeMissionSubject)} */}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default ListMissionSubjects